module.exports = __webpack_public_path__ + "static/flags/JO-c977b23ef8d4ddddf21f04db8e493fb9.gif";